import useEditMode from 'features/admin/edit-mode/useEditMode'

export function useIsEditingBlankPages(): boolean {
    const { isOpen } = useEditMode()

    return isOpen
}
